import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/54_card_back_flower_girl/54_card_back_flower_girl"
 * Contains 1 texture(s)
 */
export class CardsBacks54CardBackFlowerGirlAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/54_card_back_flower_girl/54_card_back_flower_girl';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '54_flower_girl.png'
    ] as const;
}
